import { render, staticRenderFns } from "./getvoting.vue?vue&type=template&id=7760a964"
import script from "./getvoting.vue?vue&type=script&lang=js"
export * from "./getvoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports